<template>
  <div class="d-flex flex-row justify-content-around align-items-center rfjm-add-to-calendar">
    <b-btn class="rounded mx-1 p-1" :href="calLinks.googleCalendar" target="_blank" title="Add to Google Calendar" variant="light">
      <img class="wh-20px" src="/static/images/icons/emails/gcal.svg"/>
    </b-btn>
    <b-btn class="rounded mx-1 p-1" :href="calLinks.microsoft365" target="_blank" title="Add to Microsoft Outlook" variant="light">
      <img class="wh-20px" src="/static/images/icons/emails/outl.svg"/>
    </b-btn>
    <b-btn class="rounded mx-1 p-1" :href="`data:text/calendar;charset=utf8,${vcalData.join('\n')}`" target="_blank" title="Download ICS" variant="light">
      <img class="wh-20px" src="/static/images/icons/emails/ical.png"/>
    </b-btn>
  </div>
</template>

<script>
import formatDate from 'date-fns/format';
import qs from 'querystring';

export default {
  props: {
    event: {
      type: Object,
      required: true,
      validate: event => event && event.title && event.startDate && event.endDate,
    },
  },
  computed: {
    calLinks() {
      const { title, description, location, startDate, endDate } = this.event;

      const links = {
        googleCalendar: {
          url: 'https://calendar.google.com/calendar/render',
          query: {
            action: 'TEMPLATE',
            dates: `${formatDate(startDate, 'YYYYMMDD[T]HHmm[00Z]')}/${formatDate(endDate, 'YYYYMMDD[T]HHmm[00Z]')}`,
            text: title,
            ...(description ? { details: description } : {}),
            ...(location ? { location } : {}),
          },
        },
        microsoft365: {
          url: 'https://outlook.office.com/calendar/0/deeplink/compose',
          query: {
            path: '/calendar/action/compose',
            rru: 'addevent',
            startdt: formatDate(startDate, 'YYYY-MM-DD[T]HH:mm:[00]Z'),
            enddt: formatDate(endDate, 'YYYY-MM-DD[T]HH:mm:[00]Z'),
            subject: title,
            ...(description ? { body: description } : {}),
            ...(location ? { location } : {}),
          },
        },
      };

      return Object.keys(links).reduce((ls, key) => {
        const { url, query } = links[key];
        ls[key] = `${url}?${qs.stringify(query)}`;
        return ls;
      }, {});
    },
    vcalData() {
      const { title, description, location, startDate, endDate } = this.event;
      const sanitise = str => encodeURIComponent(str);

      return (as => as.filter(a => typeof a === 'string'))([
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `DTSTART:${formatDate(startDate, 'YYYYMMDD[T]HHmm[00Z]')}`,
        `DTEND:${formatDate(endDate, 'YYYYMMDD[T]HHmm[00Z]')}`,
        title ? `SUMMARY:${sanitise(title)}` : null,
        description ? `DESCRIPTION:${sanitise(description)}` : null,
        location ? `LOCATION:${sanitise(location)}` : null,
        'END:VEVENT',
        'END:VCALENDAR',
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/referral-jam/AddToCalendar.vue